import {SODeleteBacklog} from '../../core/backlog/so-delete-backlog';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteBacklog extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteBacklog;
}